import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Apiurl } from "../../../util/apiurl";
import axiosInstance from "../../../util/axiosInstance";
import Lodaer from "../../layout/lodaer";
import CountdownTimer from "./countDowntimer";
import QuizBanner from "./quizBanner";
import QuizLeaderboard from "./quizLeaderboard";
import Loader from "../../layout/lodaer";

function QuizQuestions(props) {
  const { id, topic } = useParams();
  const navigate = useNavigate();

  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [userAnswers, setUserAnswers] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [remainingTime, setRemainingTime] = useState(0);
  const [startTime, setStartTime] = useState(null);
  const [isTimeUp, setIsTimeUp] = useState(false);

  const handleNextQuestion = () => {
    const newAnswers = [...userAnswers];
    newAnswers[currentQuestionIndex] = selectedOption;
    setUserAnswers(newAnswers);

    if (currentQuestionIndex < questions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      setSelectedOption(newAnswers[currentQuestionIndex + 1]);
    } else {
      handleSubmit(newAnswers);
    }
  };

  const handlePrevQuestion = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
      setSelectedOption(userAnswers[currentQuestionIndex - 1]);
    }
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
  };

  const handleSubmitold = async (answers) => {
    console.log("User answers: ", answers);
    const formattedAnswers = answers.reduce((acc, answer, index) => {
      acc[index + 1] = answer;
      return acc;
    }, {});

    try {
      const response = await axiosInstance.post(
        `${Apiurl.questionSubmit}/${id}`,
        formattedAnswers
      );

      console.log("Submit response: ", response.data);

      // Calculate time spent in seconds
      const endTime = new Date().getTime();
      const totalTimeSpent = Math.floor((endTime - startTime) / 1000); // in seconds
      localStorage.setItem("quizSubmissionTime", totalTimeSpent.toString());
      console.log("Time spent on quiz (seconds): ", totalTimeSpent);

      navigate(`/QuizDone/${id}/${topic}`, {
        state: { result: response.data },
      });
    } catch (error) {
      console.error("Error submitting answers: ", error);
    }
  };
  const handleSubmit = async (answers) => {
    console.log("User answers: ", answers);
    const formattedAnswers = answers.reduce((acc, answer, index) => {
      const questionType = questions[index].questionType;
  
      // Convert "True" or "False" to 1 or 0
      if (questionType === "True or False") {
        acc[index + 1] = answer === "True" ? 1 : 0;
      } else {
        acc[index + 1] = answer;
      }
  
      return acc;
    }, {});
  
    try {
      const response = await axiosInstance.post(
        `${Apiurl.questionSubmit}/${id}`,
        formattedAnswers
      );
  
      console.log("Submit response: ", response.data);
  
      // Calculate time spent in seconds
      const endTime = new Date().getTime();
      const totalTimeSpent = Math.floor((endTime - startTime) / 1000);
      localStorage.setItem("quizSubmissionTime", totalTimeSpent.toString());
      console.log("Time spent on quiz (seconds): ", totalTimeSpent);
  
      navigate(`/QuizDone/${id}/${topic}`, {
        state: { result: response.data },
      });
    } catch (error) {
      console.error("Error submitting answers: ", error);
    }
  };
  
  const fetchDataold = async () => {
    try {
      const response = await axiosInstance.get(
        `${Apiurl.questionList}/${topic}`
      );
      const fetchedQuestions = response.data.map((item) => ({
        question: item.question,
        options: item.multipleOptions.split(","),
        time: item.time,
      }));
      setQuestions(fetchedQuestions);
      setUserAnswers(Array(fetchedQuestions.length).fill(null));

      // Calculate total time for the quiz in seconds
      const totalTime = fetchedQuestions.reduce(
        (acc, question) => acc + question.time,
        0
      );
      setRemainingTime(totalTime); // Set total time in seconds

      if (currentQuestionIndex === 0) {
        setRemainingTime(totalTime);
        console.log("current question condition");
      }

      // Set the start time of the quiz
      setStartTime(new Date().getTime());

      console.log(totalTime, "total time");
      console.log(response.data, "quiz questions response");
    } catch (error) {
      console.error("Error fetching questions: ", error);
    }
  };
  const fetchData = async () => {
    try {
      const response = await axiosInstance.get(
        `${Apiurl.questionList}/${topic}`
      );
  
      const fetchedQuestions = response.data.map((item) => ({
        question: item.question,
        options: item.questionType === "True or False" ? ["True", "False"] : item.options.split(","),
        time: item.time,
        questionType: item.questionType,
      }));
  
      setQuestions(fetchedQuestions);
      setUserAnswers(Array(fetchedQuestions.length).fill(null));
  
      // Calculate total time for the quiz in seconds
      const totalTime = fetchedQuestions.reduce(
        (acc, question) => acc + question.time,
        0
      );
      setRemainingTime(totalTime);
  
      if (currentQuestionIndex === 0) {
        setRemainingTime(totalTime);
      }
  
      setStartTime(new Date().getTime());
    } catch (error) {
      console.error("Error fetching questions: ", error);
    }
  };
  

  const resetTimerOnServer = async () => {
    try {
      // Assuming you have an endpoint to reset the timer
      const response = await axiosInstance.post(
        `${Apiurl.resetTimer}/${topic}`,
        { id }
      );
      console.log("Timer reset on server: ", response.data);
    } catch (error) {
      console.error("Error resetting timer on server: ", error);
    }
  };

  useEffect(() => {
   resetTimerOnServer();
   
    // Check if the page has already been reloaded in this session
    const reloaded = sessionStorage.getItem("reloaded");
    if (!reloaded && currentQuestionIndex === 0) {
      sessionStorage.setItem("reloaded", "true");
      window.location.reload();
    } else {
      fetchData();
    }
    return () => {
      localStorage.removeItem("remainingTime");
    };
  }, []);

  // useEffect(() => {
  //   if (remainingTime > 0 && !isTimeUp) {
  //     const timer = setInterval(() => {
  //       setRemainingTime((prevTime) => prevTime - 1);
  //     }, 1000); // Update every second

  //     return () => clearInterval(timer);
  //   } else if (remainingTime === 0) {
  //     setIsTimeUp(true);
  //     // handleSubmit(userAnswers);
  //   }
  // }, [remainingTime, isTimeUp, userAnswers]);
  useEffect(() => {
    fetchData();
  }, []);

  if (questions.length === 0) {
    return <Loader />;
  }

  const currentQuestion = questions[currentQuestionIndex];

  return (
    <>
      <QuizBanner />
      <div className="container quiz-questions-ban-sec">
        <div className="row justify-content-between">
          <div className="col-12 col-md-6">
            <div className="quiz-question-section">
              <div className="progress-ques">
                <span className="prog-ques-line">
                  QUESTION {currentQuestionIndex + 1} OF {questions.length}
                </span>
                <div className="progress_bar">
                  <div
                    className="progress-status"
                    style={{
                      width: `${
                        ((currentQuestionIndex + 1) / questions.length) * 100
                      }%`,
                    }}
                  ></div>
                </div>
              </div>
              <div className="quiz-questions">
                <span className="quiz-question">
                  Q{currentQuestionIndex + 1}. {currentQuestion.question}
                </span>
                <div className="quiz-options">
                  {currentQuestion.options.map((option, index) => (
                    <span
                      key={index}
                      className="quiz-option"
                      style={{
                        backgroundColor:
                          selectedOption === option ? "#1b6098" : "#e8eff5",
                        color:
                          selectedOption === option ? "#ffffff" : "#000000",
                      }}
                      onClick={() => handleOptionClick(option)}
                    >
                      {option}
                    </span>
                  ))}
                </div>
                <div className="quiz-btns">
                  <button
                    className="quiz-prev-btn"
                    onClick={handlePrevQuestion}
                    disabled={currentQuestionIndex === 0}
                  >
                    <i className="fa fa-chevron-left"></i> Prev
                  </button>
                  <button
                    className="quiz-next-btn"
                    onClick={handleNextQuestion}
                    disabled={selectedOption === null}
                  >
                    {currentQuestionIndex === questions.length - 1
                      ? "Submit"
                      : "Next"}{" "}
                    <i className="fa fa-chevron-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-5">
            <div className="timer-sore-section">
              <div className="timer-section">
                <span className="time-sore-heading">Time remaining</span>
              </div>
              <CountdownTimer
                time={remainingTime}
                autoSubmitData={() => setIsTimeUp(true)}
              />
            </div>
            <QuizLeaderboard />
          </div>
        </div>
      </div>
    </>
  );
}

export default QuizQuestions;
